import SuperscriptIcon from '@mui/icons-material/Superscript';
import cn from 'classnames';
import React, { FC } from 'react';
import { Button } from 'reactstrap';

interface Props {
  onHandleHighlight: () => void;
  onHandleShowGraphMathPopup: () => void;
  onHandleShowFormulaPopup: () => void;
  isDisabled?: boolean;
}

export const AdvancedButtons: FC<Props> = ({
  onHandleHighlight,
  onHandleShowFormulaPopup,
  onHandleShowGraphMathPopup,
  isDisabled = false,
}) => (
  <>
    <Button className="formula-icon-between" onClick={onHandleHighlight} disabled={isDisabled}>
      {'1]-[2]-[3'}
    </Button>

    <Button className="formula-icon formula-icon-graph-math" onClick={onHandleShowFormulaPopup} disabled={isDisabled}>
      <span className="icon-graph">
        <span className={cn('icon-graph-item', isDisabled && 'disabled')} />
        <span className={cn('icon-graph-item', isDisabled && 'disabled')} />
      </span>

      <SuperscriptIcon />
    </Button>

    <Button className="formula-icon" onClick={onHandleShowGraphMathPopup} disabled={isDisabled}>
      <SuperscriptIcon />
    </Button>
  </>
);
